import type {RouteRecordRaw} from "vue-router";

export const routeName = 'DraftDoc';

export const route: RouteRecordRaw = {
    name: routeName,
    path: ':id',
    component: () => import('@/pages/Draft'),
    props: true,
    meta: {
        isHide: true,
        title: 'draft'
    }
};
